import React from "react"
import * as styles from "./disclaimer.module.scss"
import Text from './text'

export default function Disclaimer(props) {
    return <Text className={styles.disclaimer} content={props.text}/>
}